let sustainableProblems;
let sustainableProblemsCarousel;
let sustainableProblemsHeight;

function updateSustainableProblemsHeight() {
  // Remove Set Carousel Height
  document.querySelector('#shopify-section-sustainability-problems .sustainable-features').style.height = '';
    
  sustainableProblems = document.querySelector('#shopify-section-sustainability-problems .sustainable-features');
  if ( window.innerWidth < 700 ) {
    sustainableProblems.querySelectorAll('.sustainable-feature').forEach(function(item) {
      if (item.clientHeight > sustainableProblemsHeight) {
        sustainableProblemsHeight = item.clientHeight = sustainableProblemsHeight
      }
    });
  } else {
    sustainableProblemsHeight = document.querySelector('#shopify-section-sustainability-problems .sustainable-feature:nth-child(2)').clientHeight;
  }
  // Update Carousel
  document.querySelector('#shopify-section-sustainability-problems .sustainable-features').style.height = `${sustainableProblemsHeight}px`;  
}

window.addEventListener('DOMContentLoaded',function () {  
  updateSustainableProblemsHeight();
  sustainableProblemsCarousel = new Flickity( sustainableProblems, {
      cellSelector: '.sustainable-feature.cell',
	  wrapAround: false,
      imagesLoaded: true,
      pageDots: false,
      groupCells: false,
      prevNextButtons: true,
      adaptiveHeight: true,
      autoplay: false,
      cellAlign: 'left',
      watchCSS: true,
      arrowShape: { 
          x0: 10,
          x1: 60, y1: 50,
          x2: 65, y2: 45,
          x3: 20
      }
  });
});

window.addEventListener('DOMContentLoaded',function () {
  sustainableProblemsCarousel.resize();
  updateSustainableProblemsHeight();
});